var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 76.6667H35C33.16 76.6667 31.6666 75.1701 31.6666 73.3334V56.6667H23.3333C22.66 56.6667 22.05 56.2601 21.7933 55.6367C21.5366 55.0134 21.68 54.2967 22.1533 53.8201L38.82 37.1534C39.47 36.5034 40.5266 36.5034 41.1766 37.1534L57.8433 53.8201C58.32 54.2967 58.4633 55.0134 58.2033 55.6367C57.9433 56.2601 57.34 56.6667 56.6666 56.6667H48.3333V73.3334C48.3333 75.1701 46.84 76.6667 45 76.6667ZM27.3566 53.3334H33.3333C34.2533 53.3334 35 54.0801 35 55.0001V73.3334H45V55.0001C45 54.0801 45.7466 53.3334 46.6666 53.3334H52.6433L40 40.6901L27.3566 53.3334Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0033 56.5667C14.94 56.5667 14.88 56.5634 14.8133 56.5567C6.37 55.62 0 48.5 0 40C0 31.1934 6.86333 23.9634 15.52 23.3734C17.8267 11.8534 28.11 3.33337 40 3.33337C49.3367 3.33337 57.9367 8.59337 62.1767 16.8134C72.25 17.87 80 26.4067 80 36.6667C80 45.6 74.0133 53.5 65.4467 55.8734C64.5533 56.1167 63.64 55.5967 63.3967 54.71C63.15 53.8234 63.67 52.9034 64.5567 52.66C71.6867 50.6867 76.6667 44.1067 76.6667 36.6667C76.6667 27.8434 69.79 20.55 61.01 20.0634C60.3933 20.03 59.85 19.66 59.59 19.1034C56.0633 11.55 48.3767 6.66671 40 6.66671C29.2833 6.66671 20.0767 14.65 18.5833 25.2334C18.4667 26.0534 17.7633 26.6667 16.9333 26.6667C9.31333 26.6667 3.33333 32.6467 3.33333 40C3.33333 46.8 8.42667 52.4934 15.1867 53.2434C16.1 53.3467 16.76 54.17 16.6567 55.0834C16.5633 55.9367 15.84 56.5667 15.0033 56.5667Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.a8e5037a3721e5a4848d54f6d7b21c71.svg";
export { ForwardRef as ReactComponent };